import $ from 'static/script/libs/jquery';
import defineComponent from 'flight';

function SearchResultFilterCloseUI() {
    this._closeFilter = function () {
        let scrollToTop = parseInt(this.$node.parents('[data-result-layout]').offset().top, 10);
        let context = this.$node.parents('[data-expandable]').data('expandable');

        this.trigger(document, 'ui:toggle:' + context, {
            expand: false
        });

        window.scrollTo(0, scrollToTop);
    };

    this._closeCategoryFilterOnLayoutChange = function () {
        let context = this.$node.parents('[data-expandable]').data('expandable');

        if (context === 'search-filters-sort') {
            this.trigger(document, 'ui:toggle:' + context, {
                expand: false
            });
        }
    };

    this.after('initialize', function () {
        this.on('click', this._closeFilter);
        this.on(document, 'ui:search:on-layout-change', this._closeCategoryFilterOnLayoutChange);

    });
}

module.exports = defineComponent.component(SearchResultFilterCloseUI);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/search-result/search-result-filter-close-ui.js